// Shared chat bubble used by IntakePane and the main thread chat surface.

import { cn } from "@/lib/utils";

export function ChatBubble({
  role,
  streaming = false,
  children,
}: {
  role: "user" | "assistant";
  streaming?: boolean;
  children: React.ReactNode;
}) {
  return (
    <div
      className={cn(
        "flex",
        role === "user" ? "justify-end" : "justify-start"
      )}
    >
      <div
        className={cn(
          "max-w-[85%] rounded-2xl px-4 py-2.5 text-sm leading-relaxed whitespace-pre-wrap",
          role === "user"
            ? "bg-foreground text-background rounded-br-sm"
            : "bg-card text-foreground border border-border rounded-bl-sm"
        )}
      >
        {children}
        {streaming && role === "assistant" && (
          <span className="inline-block w-1.5 h-4 ml-0.5 align-middle bg-foreground/70 animate-pulse" />
        )}
      </div>
    </div>
  );
}
